export default function FunctionsText() {
  return (
    <>
      <p className="lead mt-2 mb-0">
        В цьому розділі зібрані різноманітні задачі з JavaScript, виконати які
        запропоновано як окремі функції.
      </p>
      <p className="lead mb-4">
        Ми не розділяли задачі на окремі теми (рядки, масиви, цикли, регулярні
        вирази тощо), оскільки часто одне й те ж завдання можна виконати
        декількома абсолютно різними способами.
      </p>
    </>
  );
}
